import {
  ResponsiveContextProvider,
  ResponsiveDetailCol,
  ResponsiveListCol
} from '@monorepo/common/component/responsive/ResponsiveContextProvider';
import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import OrderDetail from '../component/order/OrderDetail';
import OrderFilterableList from '../component/order/OrderFilterableList';

export default function OrdersPage() {
  const { path: parentPath, url: parentUrl } = useRouteMatch();
  const path = `${parentPath}/:orderNumber?`;
  const match = useRouteMatch<{ orderNumber?: string }>(path);
  const orderNumber = match?.params.orderNumber;

  return (
    <ResponsiveContextProvider single={false} selectedId={orderNumber}>
      <Route path={path}>
        <Container>
          <Row>
            <ResponsiveListCol>
              <div className="position-fixed-scrollable">
                <OrderFilterableList orderNumber={orderNumber} url={parentUrl} />
              </div>
            </ResponsiveListCol>

            <ResponsiveDetailCol>
              <OrderDetail orderNumber={orderNumber} listUrl={parentUrl} />
            </ResponsiveDetailCol>
          </Row>
        </Container>
      </Route>
    </ResponsiveContextProvider>
  );
}
